import { atom } from 'recoil';

export const mutationStateAtom = atom({
  key: 'mutationState',
  default: false,
});
